import { LogoText } from '@/components/displays/LogoText/LogoText';
import { Button, Flex, Stack, Text, Title } from '@mantine/core';
import { t } from 'i18next';

import { openStorePage } from './openStorePage';

/** Above the biometric lock screen: unlocking is pointless in a build that has to update first. */
const Z_INDEX = 10001;

export function UpdateRequiredScreen({ storeUrl }: { storeUrl: string | null }) {
	return (
		<Flex
			role="alertdialog"
			aria-modal="true"
			aria-label={t('appUpdate.requiredTitle')}
			direction="column"
			justify="center"
			align="center"
			pos="fixed"
			inset={0}
			bg="var(--mantine-color-body)"
			style={{
				zIndex: Z_INDEX,
				paddingTop: 'var(--safe-area-top)',
				paddingBottom: 'var(--safe-area-bottom)',
			}}
		>
			<Stack align="center" gap="md" px="lg" maw={420}>
				<LogoText maw={180} mb="lg" />
				<Title order={4}>{t('appUpdate.requiredTitle')}</Title>
				<Text c="dimmed" size="sm" ta="center">
					{storeUrl ? t('appUpdate.requiredBody') : t('appUpdate.requiredNoLink')}
				</Text>
				{storeUrl && <Button onClick={() => openStorePage(storeUrl)}>{t('appUpdate.update')}</Button>}
			</Stack>
		</Flex>
	);
}
